<template>
    <div>
        <base-dialog v-model="confidentialityDialog.visible" :content="$t('tests.work-environment.confidentialityWarning')" :okFn="async () => { confidentialityDialog.visible = false }" :cancelFn="() => { back() }" :dontShowAgainCookie="confidentialityDialog.cookie"></base-dialog>
        <test-template :testName="testName" :testId="testId" :test="test" multidimensional @setFinishedMessageResultsHidden="setMessage">
            <template #questions>
                <question-card :question="cQ" v-model="questionResult" :progress="$store.state.tests.currentSlide" :questionnaireLength="$store.state.tests.test.length"  @answerQuestion="() => { $store.commit('tests/incrementSlide') }" @submitQuestionnaire="saveTestResults"></question-card>
            </template>
            <template #results>
                <b-row align-v="center" v-if=" $store.getters['session/userIsPatient']" class="slidesSize">
                    <loading-anim :active="$store.state.loading" fullScreen></loading-anim>
                    <b-col class="px-0 pt-1 px-md-5 pt-md-2 m-auto align-middle">
                        <h3><strong>{{$t('tests.hello')}} {{ $store.state.session.user.name }},</strong></h3><br>
                        <h5 v-html="testFinishedMessage"></h5>
                    </b-col>
                </b-row>
                <div v-if="$store.getters['session/userIsProfessional']">
                    <div key="recapCard" class="second">
                        <h4>{{ $t('tests.results') }} {{ month }}</h4>
                        <b-card class="neu-card mean-result col-lg-6">
                            <h3 class="subtitle-card"> {{ $t('tests.work-environment.title') }}</h3>
                            <b-row class="h-100">
                                <b-col class="my-auto">
                                    <gauge-chart :labels="[testName]" :result="DBResults.percentage"></gauge-chart>
                                </b-col>
                            </b-row>
                        </b-card>
                    </div>
                    <div key="dimensions" class="third">
                        <h4>{{ $t('tests.dimensions') }}</h4>
                        <div class="col-lg-12 results-container">
                            <div v-for="d in DBResults.dimensions" :key="d.name" class="col-lg-8 results-card">
                                <b-col>
                                    <b-card class="neu-card" v-b-toggle="d.id" :title="$t(d.name)">
                                        <div>
                                            <span>{{ `${d.result}/${d.totalDimensionPoints}` }}</span>
                                        </div>
                                    </b-card>
                                </b-col>
                            </div>
                        </div> 
                    </div>
                </div>
            </template>
        </test-template>
    </div>
</template>


<script>
import TestTemplate from './TestTemplate.vue'
import { BProgress } from 'bootstrap-vue'
import BaseDialog from '@/components/base/BaseDialog.vue'
import selfEvaluationTestMixin from '@/mixins/selfEvaluationTest.mixin'
import { TEST_WORK_ENVIRONMENT } from '@/constants/patientServices'
import { TEST_WORK_ENVIRONMENT_DISCLAIMER_COOKIE } from '@/constants/cookies'
import { getCookie } from '@/helpers/cookies.helpers'

export default {
    mixins: [selfEvaluationTestMixin],
    components: {
        'test-template': TestTemplate,
        BProgress,
        BaseDialog,
        'gauge-chart': () => import('@/components/charts/GaugeChart.vue')
    },
    data () {
        const values = [
            {value: 1, text: this.$t('tests.answers.never')},
            {value: 2, text: this.$t('tests.answers.almostNever')},
            {value: 3, text: this.$t('tests.answers.sometimes')},
            {value: 4, text: this.$t('tests.answers.alot2')},
            {value: 5, text: this.$t('tests.answers.always')}
        ]
        const test = [
            {
                'dimension': 'tests.work-environment.dimensions.social-interaction',
                'qs': ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'],
                'questions': []
            },
            {
                'dimension': 'tests.work-environment.dimensions.communication',
                'qs': ['q7', 'q8', 'q9', 'q10', 'q11', 'q12', 'q13'],
                'questions': []
            },
            {
                'dimension': 'tests.work-environment.dimensions.work-conditions',
                'qs': ['q14', 'q15', 'q16', 'q17', 'q18'],
                'questions': []
            },
            {
                'dimension': 'tests.work-environment.dimensions.risk-prevention',
                'qs': ['q19', 'q20', 'q21'],
                'questions': []
            },
            {
                'dimension': 'tests.work-environment.dimensions.satisfaction',
                'qs': ['q22', 'q23', 'q24', 'q25', 'q26', 'q27'],
                'questions': []
            },
            {
                'dimension': 'tests.work-environment.dimensions.wage',
                'qs': ['q28', 'q29', 'q30', 'q31', 'q32'],
                'questions': []
            },
            {
                'dimension': 'tests.work-environment.dimensions.promotion',
                'qs': ['q33', 'q34', 'q35', 'q36', 'q37', 'q38', 'q39'],
                'questions': []
            },
            {
                'dimension': 'tests.work-environment.dimensions.formation',
                'qs': ['q40', 'q41', 'q42', 'q43'],
                'questions': []
            },
            {
                'dimension': 'tests.work-environment.dimensions.leadership',
                'qs': ['q44', 'q45', 'q46', 'q47', 'q48', 'q49', 'q50', 'q51', 'q52', 'q53', 'q54', 'q55', 'q56', 'q57', 'q58', 'q59', 'q60'],
                'questions': []
            },
            {
                'dimension': 'tests.work-environment.dimensions.autonomy',
                'qs': ['q61', 'q62', 'q63', 'q64', 'q65', 'q66', 'q67'],
                'questions': []
            },
            {
                'dimension': 'tests.work-environment.dimensions.client-orientation',
                'qs': ['q68', 'q69', 'q70'],
                'questions': []
            },
            {
                'dimension': 'tests.work-environment.dimensions.organization',
                'qs': ['q71', 'q72', 'q73', 'q74', 'q75', 'q76', 'q77', 'q78', 'q79', 'q80'],
                'questions': []
            },
            {
                'dimension': 'tests.work-environment.dimensions.motivation',
                'qs': ['q81', 'q82', 'q83', 'q84', 'q85', 'q86', 'q87', 'q88', 'q89', 'q90', 'q91'],
                'questions': []
            }
        ]
        return {
            test: test,
            values: values,
            testId: TEST_WORK_ENVIRONMENT,
            testName: this.$t('tests.work-environment.title'),
            testFinishedMessage: this.$t('tests.work-environment.finalCompletedMessage'),
            confidentialityDialog: {
                visible: getCookie(TEST_WORK_ENVIRONMENT_DISCLAIMER_COOKIE) !== 'true',
                cookie: TEST_WORK_ENVIRONMENT_DISCLAIMER_COOKIE
            }
        }
    },
    created () {
        this.createQuestions()
    },
    methods: {
        back () {
            window.history.back()
        },
        createQuestions () {
            var i = 1
            this.test.map(t => {
                t.id = `apartado-${i}`
                t.title = `${this.$t('tests.section')} ${i}`
                var q = []
                t.qs.map(x => q.push({
                    id: x,
                    question: this.$t(`tests.work-environment.questions.${x}`),
                    answer: this.values,
                    result: null
                }))
                i = i + 1
                t.questions = q
            })
        },
        saveTestResults () {
            var dimensions = []
            for (let dimension of this.test) {
                var dimensionValues = this.calculateMultidimensionalDimPoints(dimension)
                dimensions.push({'result': dimensionValues.sum, 'id': dimension.id, 'name': dimension.dimension, 'totalDimensionPoints': dimension.qs.length * 5})
            }
            this.save(dimensions, dimensions.map(x => x.result).reduce((x, y) => x + y, 0), this.percentResult(dimensions.map(x => x.result).reduce((x, y) => x + y, 0), 91 * 5))
        },
        setMessage () {
            this.testFinishedMessage = this.$t('tests.work-environment.finalCompletedMessageAccessAgain')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/views/selfEvaluationTests/WorkEnvironmentTest.vue